import {
  IInputPlaceSelect,
} from '@noitada/axios-config/interfaces/App/input-select-place.interface';



const CitiesFullItaVen: Array<IInputPlaceSelect> = [
  {
    id: 1,
    label: 'Milão',
    value: 'MILAN',
  },
];



export default CitiesFullItaVen;
